import { ComponentFactoryResolver, Injectable, ComponentRef } from '@angular/core';


@Injectable()
export class ComponentFactoryService {
  private compRef: ComponentRef<any>;
  constructor(private compFactoryResolver: ComponentFactoryResolver) {

  }

  createComponent(compInstance: any, viewContainer: any): ComponentRef<any> {
    const compFactory = this.compFactoryResolver.resolveComponentFactory(compInstance);
    const viewContRef = viewContainer;//.viewContainerRef;
    viewContRef.clear();
    this.compRef = viewContRef.createComponent(compFactory, 0);
    return this.compRef;
  }

  destroyComponent() {
    if (this.compRef) {
      this.compRef.destroy();
    }
  }
}
